import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

// Cliente axios configurado
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
});

// Interceptor para tratar erros
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('Erro na API de Faturas:', error);
    if (error.code === 'ECONNABORTED') {
      throw new Error('Timeout - A API está demorando para responder.');
    }
    throw error;
  }
);

// Buscar movimentos de venda
export const fetchMovimentosVenda = async (leilaoId, clienteId) => {
  try {
    console.log(`Buscando movimentos de venda - Leilão: ${leilaoId}, Cliente: ${clienteId}`);
    const response = await api.get(`/api/knorr/vendas/movimentos/${leilaoId}/${clienteId}`);
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar movimentos de venda:', error);
    throw new Error(error.response?.data?.detail || 'Erro ao buscar movimentos de venda');
  }
};

// Buscar detalhes dos lotes
export const fetchMovimentosLote = async (leilaoId, clienteId) => {
  try {
    console.log(`Buscando movimentos de lote - Leilão: ${leilaoId}, Cliente: ${clienteId}`);
    const response = await api.get(`/api/knorr/vendas/movimentos-lote/${leilaoId}/${clienteId}`);
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar movimentos de lote:', error);
    throw new Error(error.response?.data?.detail || 'Erro ao buscar detalhes dos lotes');
  }
};

// Buscar dados do comprador
export const fetchMovimentosComprador = async (leilaoId, clienteId) => {
  try {
    console.log(`Buscando dados do comprador - Leilão: ${leilaoId}, Cliente: ${clienteId}`);
    const response = await api.get(`/api/knorr/vendas/movimentos-comprador/${leilaoId}/${clienteId}`);
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar dados do comprador:', error);
    throw new Error(error.response?.data?.detail || 'Erro ao buscar dados do comprador');
  }
};

// Buscar parcelamento
export const fetchMovimentosParcelas = async (leilaoId, clienteId) => {
  try {
    console.log(`Buscando parcelamento - Leilão: ${leilaoId}, Cliente: ${clienteId}`);
    const response = await api.get(`/api/knorr/vendas/movimentos-parcelas/${leilaoId}/${clienteId}`);
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar parcelamento:', error);
    throw new Error(error.response?.data?.detail || 'Erro ao buscar parcelamento');
  }
};

// Buscar dados completos da fatura
export const fetchFaturaCompleta = async (leilaoId, clienteId) => {
  try {
    console.log(`Buscando fatura completa - Leilão: ${leilaoId}, Cliente: ${clienteId}`);
    
    // Buscar todos os dados em paralelo
    const [movimentos, lotes, comprador, parcelas] = await Promise.all([
      fetchMovimentosVenda(leilaoId, clienteId),
      fetchMovimentosLote(leilaoId, clienteId),
      fetchMovimentosComprador(leilaoId, clienteId),
      fetchMovimentosParcelas(leilaoId, clienteId)
    ]);

    return {
      movimentos,
      lotes,
      comprador,
      parcelas
    };
  } catch (error) {
    console.error('Erro ao buscar fatura completa:', error);
    throw error;
  }
};

// Função para formatar moeda
export const formatCurrency = (value) => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(value);
};

// Função para formatar data
export const formatDate = (dateString) => {
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  } catch {
    return dateString;
  }
};